document.addEventListener("DOMContentLoaded", () => {
  const leftItems = document.querySelectorAll(".column-image_qBiyyn, .column-text_NgyLjG");
  const rightItems = document.querySelectorAll(".column-image_BbiCCk, .column-image_FLJJGp");

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");
        obs.unobserve(entry.target); // ek dafa hi chale
      }
    });
  }, { threshold: 0.2 });

  leftItems.forEach(item => observer.observe(item));
  rightItems.forEach(item => observer.observe(item));


});

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector("#LM--template--17863579336806__lumin_mega_RnVUDV, .email-signup-banner__box");

  if (section) {
    section.classList.add("lumin-animate-up");

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target); // ek bar hi animate hoga
          }
        });
      },
      { threshold: 0.2 } // 20% visible hone par trigger hoga
    );

    observer.observe(section);
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const bannerContent = document.querySelector(
    "#Banner-template--17863579336806__email_signup_banner_gGbY9t .banner__content"
  );

  if (bannerContent) {
    bannerContent.classList.add("banner-animate-up");

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target); // ek bar animate hoga
          }
        });
      },
      { threshold: 0.2 } // jab 20% section viewport me ho
    );

    observer.observe(bannerContent);
  }
});


window.addEventListener("scroll", function() {
    var header = document.querySelector("#shopify-section-sections--17863579697254__announcement-bar"); 
    if (window.scrollY > 10) { 
        header.classList.add("scrolled");
    } else {
        header.classList.remove("scrolled");
    }
});

window.addEventListener("scroll", function() {
    var header = document.querySelector("#shopify-section-sections--17863579697254__header"); 
    if (window.scrollY > 10) { 
        header.classList.add("scrolled");
    } else {
        header.classList.remove("scrolled");
    }
});





document.addEventListener("DOMContentLoaded", function () {
  const section = document.getElementById("shopify-section-template--17863579336806__featured_collection_WDQYjK");

  if (section) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.classList.add("active-section"); // 👈 yeh class add hogi
          observer.unobserve(section); // ek hi dafa trigger hoga
        }
      });
    }, { threshold: 0.3 }); // 30% section visible hote hi trigger hoga

    observer.observe(section);
  }
});


  
